module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) { fox.registerWidget('SitePage_About', {}, 'Site_Page'); })(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/about.js
// module id = 888
// module chunks = 4